import { getCoreSonarObjectsStakeholdersSlice } from './get';
import { putCoreSonarObjectsStakeholdersSlice } from './put';

export const {
	requestGetCoreSonarObjectsStakeholders,
	resetGetCoreSonarObjectsStakeholders
} = getCoreSonarObjectsStakeholdersSlice.asyncActionCreators;

export const {
	requestPutCoreSonarObjectsStakeholders,
	resetPutCoreSonarObjectsStakeholders
} = putCoreSonarObjectsStakeholdersSlice.asyncActionCreators;

export * from './bulk/actions';
